(() => {
  const getHashTarget = (hash = window.location.hash) => {
    if (!hash || hash === '#') return null;

    try {
      return document.getElementById(decodeURIComponent(hash.slice(1)));
    } catch (error) {
      return document.getElementById(hash.slice(1));
    }
  };

  const scrollToHash = (hash = window.location.hash) => {
    const target = getHashTarget(hash);
    if (!target) return false;

    target.scrollIntoView({ block: 'start', behavior: 'auto' });
    return true;
  };

  const initializeAnchorLinks = (root = document) => {
    root.querySelectorAll('a[href*="#"]').forEach((link) => {
      if (link.dataset.lumenAnchorInitialized === 'true') return;

      link.dataset.lumenAnchorInitialized = 'true';
      link.addEventListener('click', (event) => {
        const url = new URL(link.href, window.location.href);
        const isCurrentPage = url.origin === window.location.origin
          && url.pathname === window.location.pathname
          && url.search === window.location.search;

        if (!isCurrentPage || !url.hash || !getHashTarget(url.hash)) return;

        event.preventDefault();
        window.history.pushState(null, '', url.hash);
        scrollToHash(url.hash);
      });
    });
  };

  const initializeMobileBuyBars = (root = document) => {
    root.querySelectorAll('.lb-mobile-buy').forEach((bar) => {
      if (bar.dataset.lumenInitialized === 'true') return;

      const shell = bar.closest('.lb-shell');
      const trigger = shell?.querySelector('.lb-hero__actions, .lb-shop-hero');
      bar.dataset.lumenInitialized = 'true';

      if (!trigger) {
        bar.classList.add('is-visible');
        bar.removeAttribute('aria-hidden');
        return;
      }

      let ticking = false;
      const update = () => {
        const shouldShow = trigger.getBoundingClientRect().bottom < 0;
        bar.classList.toggle('is-visible', shouldShow);
        bar.toggleAttribute('aria-hidden', !shouldShow);
        ticking = false;
      };

      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      };

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      update();
    });
  };

  const initializeProductForms = (root = document) => {
    root.querySelectorAll('[data-lumen-default-variant]').forEach((variantControl) => {
      const form = variantControl.closest('form[action*="/cart/add"]');
      const defaultVariant = variantControl.dataset.lumenDefaultVariant;
      if (!form || !defaultVariant || form.dataset.lumenVariantGuard === 'true') return;

      form.dataset.lumenVariantGuard = 'true';
      const restoreVariant = () => {
        if (variantControl.value) return;

        variantControl.value = defaultVariant;
        if (variantControl.matches('input')) {
          variantControl.setAttribute('value', defaultVariant);
        }
      };

      restoreVariant();
      window.requestAnimationFrame(restoreVariant);
      form.addEventListener('submit', restoreVariant, true);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeAnchorLinks();
      initializeMobileBuyBars();
      initializeProductForms();
    });
  } else {
    initializeAnchorLinks();
    initializeMobileBuyBars();
    initializeProductForms();
  }

  window.addEventListener('load', () => {
    if (!window.location.hash) return;
    window.requestAnimationFrame(() => scrollToHash());
  });

  window.addEventListener('popstate', () => scrollToHash());

  document.addEventListener('shopify:section:load', (event) => {
    initializeAnchorLinks(event.target);
    initializeMobileBuyBars(event.target);
    initializeProductForms(event.target);
  });
})();
